<template>
  <div class="yjzpfdzh-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="申请状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="审核中" :value="1" />
                <el-option label="审核通过" :value="2" />
                <el-option label="审核拒绝" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="是否无限期">
              <el-select v-model="searchForm.isWx" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="否" :value="0" />
                <el-option label="是" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="审核时间">
              <el-date-picker
                v-model="searchForm.auitTimes"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="余额区间">
              <el-input v-model="searchForm.bs" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 140px"
                placeholder="最小余额"><template slot="append">元</template></el-input>
              ~
              <el-input v-model="searchForm.be" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 140px"
                placeholder="最大余额"><template slot="append">元</template></el-input>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
            <el-form-item style="float: right; position: relative; z-index: 999;">
              <el-button type="primary" @click="editApply(0)" icon="el-icon-plus">添加返点</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="返点名称"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.delname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="返点总额"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="余额"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.balance}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="抵款方式"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.credit===0">最高冲抵{{scope.row.maximpact}}%</span>
                      <span v-if="scope.row.credit===1">享受{{scope.row.maxdiscount}}折</span>
                      <span v-if="scope.row.credit===9">任意冲抵</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="有效期"
                    width="200"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.starttime==='0'">无期限</span>
                      <span v-if="scope.row.starttime!=='0'">{{scope.row.starttime}} ~ {{scope.row.endtime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.username}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审核时间"
                    width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.audittime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">审核通过</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">审核拒绝</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-dropdown v-if="scope.row.mark!==2" size="mini" @click="editApply(scope.row.darid)" split-button icon="el-icon-edit">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="delApply(scope.row.darid)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除申请</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button icon="el-icon-search" @click="view(scope.row)" size="mini" v-if="scope.row.mark===2">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info"></i> 申请须知：该申请仅限" <b>业绩/支票返点</b> "使用，实际收款/售后赔款/报备金请勿在此申请
        </div>
        <el-form-item label="审核信息" v-if="audittime!==null&&audittime!==''">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{audittime}}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{auditname}}</span>
            </div>
            <div style="color:#606266;font-size: 13px;" v-if="auditrson!==''&&auditrson!==null">
              <span style="color:#99a9bf">拒绝原因：</span>{{auditrson}}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="经销商" prop="delid">
          <el-select v-model="editForm.delid" filterable clearable style="width:400px">
            <el-option
              v-for="item in dealerInfo"
              :key="item.delid"
              :label="item.allname"
              :value="item.delid">
              <span style="float: left">{{ item.allname }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.province }} {{ item.city }} {{ item.county }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返点名称" prop="name">
          <el-input v-model="editForm.name" maxlength="200" placeholder="请输入业绩/支票返点名称" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="返点总额" prop="amount">
          <el-input v-model="editForm.amount" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="抵款方式" prop="credit">
          <el-radio-group v-model="editForm.credit">
            <el-radio :label="0">限制冲抵</el-radio>
<!--            <el-radio :label="1">享受折扣</el-radio>-->
            <el-radio :label="9">任意冲抵</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="最高冲抵" prop="maximpact" v-if="editForm.credit===0">
          <el-input v-model="editForm.maximpact" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">%</template></el-input>
        </el-form-item>
        <el-form-item label="享受折扣" prop="maxdiscount" v-if="editForm.credit===1">
          <el-input v-model="editForm.maxdiscount" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">折</template></el-input>
        </el-form-item>
        <el-form-item label="使用期限" prop="term">
          <el-radio-group v-model="editForm.term">
            <el-radio :label="0">无期限</el-radio>
            <el-radio :label="1">固定期限</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期" prop="time" v-if="editForm.term===1">
          <el-date-picker
            v-model="editForm.time"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="适用订单" prop="ordertype">
          <el-radio-group v-model="editForm.ordertype">
            <el-radio :label="0">无限制</el-radio>
            <el-radio :label="1">正单</el-radio>
            <el-radio :label="2">补单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单金额满" prop="order_money">
          <el-input v-model="editForm.order_money" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 265px"><template slot="append">元以上可享受</template></el-input>
        </el-form-item>
        <el-form-item label="最低折扣" prop="mindiscount">
          <el-input v-model="editForm.mindiscount" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width: 330px"><template slot="append">折（同比享受最低折扣）</template></el-input>
        </el-form-item>
        <el-form-item label="返点凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="editimgList" :key="imgLoad" v-model="editForm.imgids" />
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input type="textarea" v-model="editForm.remark"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="业绩/支票返点详情"
      :visible.sync="viewVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewdata.delname }}</td>
          <th>返点名称</th>
          <td colspan="3" style="color:#000;">{{ viewdata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewdata.starttime==='0'"><i class="el-icon-date"></i> 无期限</span>
            <span v-if="viewdata.starttime!=='0'"><i class="el-icon-date"></i> {{viewdata.starttime}} ~ {{viewdata.endtime}}</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.amount }}</td>
          <th>抵款方式</th>
          <td colspan="3">
            <span v-if="viewdata.credit===0">最高冲抵{{viewdata.maximpact}}%</span>
            <span v-if="viewdata.credit===1">享受{{viewdata.maxdiscount}}折</span>
            <span v-if="viewdata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.balance }}</td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewdata.ordertype===0">无限制</span>
            <span v-if="viewdata.ordertype===1">正单</span>
            <span v-if="viewdata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{viewdata.orderMoney}} 元以上可享受，同比享受最低折扣不低于 {{viewdata.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewdata.remark }}</td>
        </tr>
        <tr  v-if="viewdata.mark===2">
          <th>审核人</th>
          <td>{{ viewdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerAccountRebateApplyList, excelDealerAccountRebateApplyList, getErpDealerList, addOrEditDealerAccountRebate, getDealerAccountRebateById, deleteDealerAccountRebate } from '@/api/erp'
import MultiImg from '@/components/upload/MultiImg'
import OrderChoose from '@/components/OrderChoose'

export default {
  name: 'yjzpfdzh',
  computed: {
    user: getUser
  },
  components: {
    MultiImg,
    OrderChoose
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (value !== null && value !== undefined) {
        if (value.length !== 2) {
          callback(new Error('请选择有效期'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请选择有效期'))
      }
    }
    return {
      searchForm: {
        search: '',
        auitTimes: [],
        st: '',
        et: '',
        bs: '',
        be: '',
        type: null,
        isWx: null
      },
      btnLoading: false,
      viewVisible: false,
      viewLoading: false,
      imgSrcList: [],
      viewdata: [],
      fullscreenLoading: false,
      editTitle: '添加收款申请',
      dealerInfo: [],
      imgLoad: '',
      editimgList: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      audittime: '',
      auditname: '',
      auditrson: '',
      infoLoading: false,
      editForm: {
        darid: null,
        delid: '',
        name: '',
        amount: null,
        credit: 0,
        maximpact: null,
        maxdiscount: null,
        term: 0,
        time: [],
        ordertype: 0,
        order_money: 0,
        mindiscount: null,
        remark: '',
        imgids: []
      },
      editRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        name: [{ required: true, message: '请输入返点名称', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入返点总额', trigger: 'blur' }],
        credit: [{ required: true, message: '请选择抵款方式', trigger: 'change' }],
        term: [{ required: true, message: '请选择使用期限', trigger: 'change' }],
        time: [{ required: true, trigger: 'change', validator: validateTime }],
        maximpact: [{ required: true, message: '请输入最高冲抵', trigger: 'blur' }],
        maxdiscount: [{ required: true, message: '请输入享受折扣', trigger: 'blur' }],
        ordertype: [{ required: true, message: '请选择适用订单', trigger: 'change' }],
        order_money: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        mindiscount: [{ required: true, message: '请输入最低折扣', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传返点凭证', trigger: 'change' }]
      },
      editloading: false
    }
  },
  created() {
    this.getData()
    getErpDealerList({ userid: this.user.dUserid }).then(response => {
      this.dealerInfo = response.data
    }).catch(() => {
      this.dealerInfo = []
    })
  },
  methods: {
    Search() {
      this.searchForm.st = ''
      this.searchForm.et = ''
      if (this.searchForm.auitTimes && this.searchForm.auitTimes.length == 2) {
        this.searchForm.st = this.searchForm.auitTimes[0]
        this.searchForm.et = this.searchForm.auitTimes[1]
      }
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        st: this.searchForm.st || null,
        et: this.searchForm.et || null,
        bs: this.searchForm.bs || null,
        be: this.searchForm.be || null,
        isWx: this.searchForm.isWx || null,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid
      }
      getDealerAccountRebateApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editApply(id) {
      if (id === 0) {
        this.editTitle = '添加业绩/支票返点申请'
        this.editForm.darid = 0
        this.editForm.delid = ''
        this.editForm.name = ''
        this.editForm.amount = null
        this.editForm.credit = 0
        this.editForm.maximpact = null
        this.editForm.maxdiscount = null
        this.editForm.term = 0
        this.editForm.time = []
        this.editForm.ordertype = 0
        this.editForm.order_money = 0
        this.editForm.mindiscount = null
        this.editForm.remark = ''
        this.editForm.imgids = []
        this.editimgList = []
        this.audittime = ''
        this.auditname = ''
        this.auditrson = ''
        this.imgLoad = new Date().getTime()
      } else {
        this.editTitle = '编辑业绩/支票返点申请'
        this.infoLoading = true
        getDealerAccountRebateById({ darid: id }).then(response => {
          this.editForm.darid = response.data.dar.darid
          this.editForm.delid = response.data.dar.delid
          this.editForm.name = response.data.dar.name
          this.editForm.amount = response.data.dar.amount
          this.editForm.credit = response.data.dar.credit
          this.editForm.maximpact = response.data.dar.maximpact
          this.editForm.maxdiscount = response.data.dar.maxdiscount
          if (response.data.dar.starttime !== '0') {
            this.editForm.term = 1
            this.editForm.time = []
            this.editForm.time.push(response.data.dar.starttime)
            this.editForm.time.push(response.data.dar.endtime)
          } else {
            this.editForm.term = 0
            this.editForm.time = []
          }
          this.editForm.ordertype = response.data.dar.ordertype
          this.editForm.order_money = response.data.dar.orderMoney
          this.editForm.mindiscount = response.data.dar.mindiscount
          this.editForm.remark = response.data.dar.remark
          this.audittime = response.data.dar.audittime
          this.auditname = response.data.dar.auditname
          this.auditrson = response.data.dar.rson
          let oldimgList = []
          for (let img of response.data.imgs) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.editimgList = oldimgList
          this.imgLoad = new Date().getTime()
          this.infoLoading = false
        }).catch(() => {
          this.infoLoading = false
        })
      }
      this.editVisible = true
    },
    delApply(id) {
      this.$confirm('删除此业绩/支票返点申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteDealerAccountRebate({ userid: this.user.dUserid, darid: id }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let starttime = '0'
            let endtime = '0'
            if (this.editForm.term === 1) {
              starttime = this.editForm.time[0]
              endtime = this.editForm.time[1]
            }
            const data = {
              userid: this.user.dUserid,
              groupid: this.user.dGroupid,
              darid: this.editForm.darid,
              delid: this.editForm.delid,
              name: this.editForm.name,
              amount: this.editForm.amount,
              credit: this.editForm.credit,
              maximpact: this.editForm.maximpact,
              maxdiscount: this.editForm.maxdiscount,
              starttime: starttime,
              endtime: endtime,
              ordertype: this.editForm.ordertype,
              order_money: this.editForm.order_money,
              mindiscount: this.editForm.mindiscount,
              remark: this.editForm.remark,
              imgStr: this.editForm.imgids.join(',')
            }
            addOrEditDealerAccountRebate(data).then(response => {
              this.$message({
                message: '返点申请提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.editimgList = []
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    view(row) {
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      getDealerAccountRebateById({ darid: row.darid }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.dar
        let imgs = []
        for (let c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    },

    exportExcel() {
      this.searchForm.st = ''
      this.searchForm.et = ''
      if (this.searchForm.auitTimes && this.searchForm.auitTimes.length == 2) {
        this.searchForm.st = this.searchForm.auitTimes[0]
        this.searchForm.et = this.searchForm.auitTimes[1]
      }
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        st: this.searchForm.st || null,
        et: this.searchForm.et || null,
        bs: this.searchForm.bs || null,
        be: this.searchForm.be || null,
        isWx: this.searchForm.isWx || null,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid
      }
      this.btnLoading = true
      let file = null
      excelDealerAccountRebateApplyList(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    downLoad(file) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
    },

  }
}
</script>

<style lang="scss" scoped>
.yjzpfdzh-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
